import { render, staticRenderFns } from "./CatalogCategoryItemImages.vue?vue&type=template&id=02f10bb2"
import script from "./CatalogCategoryItemImages.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogCategoryItemImages.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports